import { root } from './crosspost-destinations';

export const crosspostDestinations = {
  ...root,
};
